// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `v-overview-panel {
  display: grid;
  grid-template-columns: [toggle-start] min-content [toggle-end title-start] max-content [title-end center-start] 1fr [center-end action-start] auto [action-end];
  gap: 0.5rem 1rem;
  grid-column: toggle/action;
}
v-overview-panel > .panel {
  border: 1px solid var(--gc-border-color);
  border-radius: 3px;
}
v-overview-panel > .panel > .header {
  background: var(--gc-color-light);
  min-height: 59px;
  padding: 0.5rem 1.25rem;
}
v-overview-panel > .panel > .header > .header-content.no-content {
  padding-left: 32px;
  min-height: 32px;
  margin-left: 0.5rem;
}
v-overview-panel > .panel > .content {
  grid-column: toggle/action;
  height: auto;
  display: grid;
  transition: grid-template-rows 500ms;
}
v-overview-panel > .panel > .content > .content-container {
  overflow: hidden;
}
v-overview-panel .panel, v-overview-panel .panel > .header {
  display: grid;
  grid-column: toggle/action;
  grid-template-columns: subgrid;
  align-items: center;
}
v-overview-panel .panel > .toggle, v-overview-panel .panel > .header > .toggle {
  grid-column: toggle;
}
v-overview-panel .panel > .toggle button, v-overview-panel .panel > .header > .toggle button {
  background: transparent;
}
v-overview-panel .panel > .header > .header-content, v-overview-panel .panel > .header > .header-content > .header, v-overview-panel .panel > .header > .header > .header-content, v-overview-panel .panel > .header > .header > .header-content > .header {
  display: contents;
}
v-overview-panel .panel > .header > .header-content .title, v-overview-panel .panel > .header > .header-content > .header .title, v-overview-panel .panel > .header > .header > .header-content .title, v-overview-panel .panel > .header > .header > .header-content > .header .title {
  grid-column: title;
  max-width: 60ch;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

v-overview-panel.pad-content > .panel > .content > .content-container > * {
  padding: 0.5rem 1.25rem;
  background: var(--gc-background-color);
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-overview-panel/v-overview-panel.component.sass"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,+JAAA;EACA,gBAAA;EACA,0BAAA;AADJ;AAGI;EACI,wCAAA;EACA,kBAAA;AADR;AAEQ;EACI,iCAAA;EACA,gBAAA;EACA,uBAAA;AAAZ;AAGgB;EACI,kBAlBP;EAmBO,gBAnBP;EAoBO,mBAAA;AADpB;AAIQ;EACI,0BAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;AAFZ;AAIY;EACI,gBAAA;AAFhB;AAII;EACI,aAAA;EACA,0BAAA;EACA,8BAAA;EACA,mBAAA;AAFR;AAGQ;EACI,mBAAA;AADZ;AAEY;EACI,uBAAA;AAAhB;AACQ;EACI,iBAAA;AACZ;AAAY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAEhB;;AAEI;EACI,uBAAA;EACA,sCAAA;AACR","sourcesContent":["$toggleSize: 32px\n\nv-overview-panel\n    display: grid\n    grid-template-columns: [toggle-start] min-content [toggle-end title-start] max-content [title-end center-start] 1fr [center-end action-start] auto [action-end]\n    gap: 0.5rem 1rem\n    grid-column: toggle/action\n\n    > .panel\n        border: 1px solid var(--gc-border-color)\n        border-radius: 3px\n        > .header \n            background: var(--gc-color-light)\n            min-height: 59px\n            padding: 0.5rem 1.25rem\n\n            > .header-content\n                &.no-content\n                    padding-left: $toggleSize\n                    min-height: $toggleSize\n                    margin-left: 0.5rem\n    \n        \n        > .content\n            grid-column: toggle/action\n            height: auto\n            display: grid\n            transition: grid-template-rows 500ms\n\n            > .content-container\n                overflow: hidden\n\n    .panel, .panel > .header\n        display: grid\n        grid-column: toggle/action\n        grid-template-columns: subgrid\n        align-items: center\n        > .toggle\n            grid-column: toggle\n            button \n                background: transparent\n        > .header > .header-content, > .header > .header-content > .header\n            display: contents\n            .title\n                grid-column: title\n                max-width: 60ch\n                overflow: hidden\n                white-space: nowrap\n                text-overflow: ellipsis\n\n\nv-overview-panel.pad-content\n    > .panel > .content > .content-container > *\n        padding: 0.5rem 1.25rem\n        background: var(--gc-background-color)"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
